import { MapPin } from 'lucide-react';
import { useLyrraOneRegional } from '@/hooks/useLyrraOneRegional';
import { LYRRAONE_PUBLIC_REGIONS } from '@/lib/lyrraone-market-config';

export function LyrraOneRegionSelector() {
  const { region, setRegion, tx } = useLyrraOneRegional('lyrraoneFooter');

  return (
    <div className="w-full flex flex-col gap-3">
      <span className="flex items-center gap-1.5 text-[#475569] text-sm">
        <MapPin className="w-4 h-4 shrink-0 text-[#2563EB]" aria-hidden />
        {tx('region.label')}
      </span>
      <div
        className="flex w-full flex-nowrap items-center justify-between gap-1 sm:gap-2"
        role="group"
        aria-label={tx('region.label')}
      >
        {LYRRAONE_PUBLIC_REGIONS.map((value) => (
          <button
            key={value}
            type="button"
            onClick={() => setRegion(value)}
            className={`min-w-0 flex-1 truncate rounded-full px-2 py-1.5 text-center text-[10px] font-semibold leading-tight transition-colors sm:px-3 sm:text-xs ${
              region === value
                ? 'bg-[#2563EB] text-white'
                : 'bg-[#F1F5F9] text-[#475569] hover:bg-[#E2E8F0]'
            }`}
            aria-pressed={region === value}
            title={tx(`region.${value}`)}
          >
            {tx(`region.${value}`)}
          </button>
        ))}
      </div>
    </div>
  );
}
